import React from "react";
import { Sparkles } from "lucide-react";
import { useI18n } from "../lib/i18n";

export default function SuggestedQuestions({ onPick }) {
  const { t } = useI18n();
  const items = t("chat.suggItems");
  return (
    <div
      className="bg-white border border-primary/15 rounded-sm p-5 shadow-sm"
      data-testid="suggested-questions"
    >
      <div className="flex items-center gap-2 mb-4">
        <Sparkles size={15} className="text-accent" />
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-primary font-semibold">
          {t("chat.suggestions")}
        </span>
      </div>
      <ul className="space-y-2">
        {items.map((q, i) => (
          <li key={i}>
            <button
              type="button"
              onClick={() => onPick(q)}
              className="group w-full text-left px-3 py-2.5 rounded-sm border border-primary/10 hover:border-accent hover:bg-accent/5 transition-all text-sm text-foreground/80 hover:text-foreground"
              data-testid={`suggestion-${i}`}
            >
              <span className="font-mono text-[10px] text-accent/70 mr-2">
                0{i + 1}
              </span>
              {q}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
